
const getters = {
  getInsurances: state => state.insurances,
  getInsurance: state => insuranceIndex => state.insurances[insuranceIndex].insurances,
  getInsuranceForm: state => insuranceIndex => state.insurances[insuranceIndex].form,
  // eslint-disable-next-line
  getInsuranceFormForSearch: (state, getters) => insuranceIndex => ({
    ...getters.getInsuranceForm(insuranceIndex),
    countryId: getters.getLocations.countryTo.slug,
    currency: getters.getCartPrice.currency
  }),
  getInsuranceCurrent: state => target => state.insurances[target].insurances.current.slug
}

export default getters